import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.last-index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";

String.prototype.hashCode = function () {
  var hash = 0;
  if (this.length === 0) return hash;

  for (var i = 0; i < this.length; i++) {
    var _char = this.charCodeAt(i);

    hash = (hash << 5) - hash + _char;
    hash = hash & hash; // Convert to 32bit integer
  }

  return hash;
};

var isServer = typeof window === 'undefined';
var defaultPic = '5cad2d3f-61a8-4184-a0a3-5cd3bfea006e.png';
var sizeOptions = [0, 46, 64, 96, 132];
var picCdnReg = /^(https:\/\/)?(\w+[1-8]\.58cdn\.com\.cn|\w+[1-6]\.zhuanstatic\.com)\//i;
var vodCdnReg = /^(https:\/\/)?vod[1-6]\.zhuanstatic\.com\//i; //hashCode方法单独抽离，避免挂到String.prototype被覆盖

var hashCode = function hashCode(str) {
  var hash = 0;
  if (!str || str.length === 0) return hash;

  for (var i = 0; i < str.length; i++) {
    var _char2 = str.charCodeAt(i);

    hash = (hash << 5) - hash + _char2;
    hash = hash & hash; // Convert to 32bit integer
  }

  return hash;
};

var ratio = function () {
  if (isServer) {
    return 1;
  }

  return window.devicePixelRatio / 2;
}(); //官方推荐的检测方式，能够在iOS14上检测webp，不足点是异步的


function checkWebpFeature(callback) {
  var img = new Image();

  img.onload = function () {
    callback(img.width > 0 && img.height > 0);
  };

  img.onerror = function () {
    callback(false);
  };

  img.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
}

var _isSupportWebp = !![].map && !isServer && document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0; //如果通用检测不支持，在用官方推荐的方式确认一遍


if (!_isSupportWebp && !isServer) {
  checkWebpFeature(function (result) {
    _isSupportWebp = result;
  });
}

var isSupportWebp = function isSupportWebp(option) {
  if (isServer) {
    return option && option.ssrWebp;
  }

  return _isSupportWebp;
};

function isArray(obj) {
  return Array.isArray ? Array.isArray(obj) : Object.prototype.toString.call(obj) === '[object Array]';
}

function isValid(url) {
  return url && ['null', 'undefined'].indexOf(url.toLowerCase()) === -1;
}

function logic(url, width, height, option) {
  if (!isValid(url)) {
    url = defaultPic;
  }

  if (/^data:image\/.+;base64/.test(url)) {
    // base64文件直接返回
    return url;
  }

  if (!/^https:/.test(url)) {
    // http及动态协议强制转https协议
    url = url.replace(/http:\/\/|\/\//, 'https://');
  }

  if (/^http(s):\/\/img\.58cdn\.com\.cn/.test(url)) {
    // img.58cdn.com.cn域名强制转为img1.zhuanstatic.com域名
    url = url.replace('img.58cdn.com.cn', 'img1.zhuanstatic.com');
  }

  if (/^http(s):\/\/pic[1-8]\.58cdn\.com\.cn/.test(url)) {
    // pic[1-8].58cdn.com.cn域名强制转为pic1.zhuanstatic.com域名
    url = url.replace(/pic[1-8]\.58cdn\.com\.cn/, 'pic1.zhuanstatic.com');
  }

  if (width || height || option) {
    // 如果存在设置width, height, option情况, myqcloud.com替换成pic1.zhuanstatic.com
    url = url.replace(/zzpic-([0-9]\d+)?\.cos\.ap-beijing\.myqcloud.com/, 'pic1.zhuanstatic.com');
  } // 处理图片宽高，因为设计稿是750，所以需要对宽高乘以1.5，在3倍屏上可以更加清晰


  if (!option || option.useOrigin !== true) {
    width = Math.floor((width || 0) * ratio);
    height = Math.floor((height || 0) * ratio);
  }

  if (/wx\.qlogo\.cn/.test(url)) {
    // 微信头像
    return wxImg(url, option);
  }

  if (/^(?!https?:\/\/)/.test(url)) {
    // 没有协议的图片先添加协议
    return addHttp(url, width, height, option);
  }

  if (picCdnReg.test(url) && !vodCdnReg.test(url)) {
    // cdn的图片且非视频cdn的图片
    return resetPic(url, width, height, option);
  }

  return url;
}

function doMake(url, width, height, option) {
  // 转换 webp、裁剪
  var dot = url.indexOf('?') === -1 ? '?' : '&';
  var w = width && !/[&?]w=/i.test(url) ? dot + 'w=' + width : '';
  dot = w ? '&' : dot;
  var h = height && !/[&?]h=/i.test(url) ? dot + 'h=' + height : '';
  var getWebp = (!option || !option.disableWebp) && isSupportWebp(option); // 目前限定 zhuanstatic.com 和 58cdn.com.cn 支持 webp, gif 不处理

  if (getWebp && picCdnReg.test(url) && !/[&?]t=/i.test(url) && !/.gif$/i.test(url)) {
    dot = h ? '&' : dot;
    return url + w + h + dot + 't=5&qa=90';
  } else if (!getWebp && /[&?]t=5/i.test(url)) {
    var sliceUrl = url.replace(/t=5(&)?/g, '').replace(/[?|&]$/, '');
    return sliceUrl + w + h;
  } else {
    return url + w + h;
  }
}

function wxImg(url, option) {
  var _index = url.lastIndexOf('/');

  var _defaultWidth = url.slice(_index + 1) ? +url.slice(_index + 1) : undefined; // 避免空字符串转为0


  var _width = getWxAvatarWidth(option, _defaultWidth);

  return url.substr(0, _index) + '/' + _width;
}

function resetPic(url, width, height, option) {
  var _url = '';
  var matchRule = /_\d+_\d+(\.png$|\.jpg$|\.gif$|\.jpeg$|\.bmp$|\.pic$)/i; //适配n_v2c6353260720d43d8bd65735d070368a2_300_300.jpg格式

  if (matchRule.test(url)) {
    var bott = matchRule.exec(url)[0];
    var dot = bott.lastIndexOf('.');
    var suf = bott.substr(dot, bott.length - 1);
    _url = url.replace(bott, suf);
  } else {
    _url = url;
  }

  return doMake(_url, width, height, option);
}

function addHttp(url, width, height, option) {
  if (/\.com\.cn/.test(url) || /\.com/.test(url)) {
    return doMake('https://' + url, width, height, option);
  }

  var _url = '';
  var filename = /^\//g.test(url.trim()) ? url.substr(1) : url;
  var random = Math.abs(hashCode(filename)) % 6 + 1;

  if (filename.indexOf('zhuanzh/') === -1) {
    _url = 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + filename;
  } else {
    _url = 'https://pic' + random + '.zhuanstatic.com/' + filename;
  }

  return resetPic(_url, width, height, option);
}

function getWxAvatarWidth(option, defaultWidth) {
  if (!option || typeof option.wxAvatarWidth !== 'number' || sizeOptions.indexOf(option.wxAvatarWidth) === -1) {
    return sizeOptions.indexOf(defaultWidth) > -1 ? defaultWidth : 96;
  }

  return option.wxAvatarWidth;
}
/**
 * 图片大小处理
 * @method setPicSize
 * @param {String | String[]} url 图片的地址或 `hash` 值，支持数组（返回也是数组）。以 `|` 分割的字符串，会返回第一个合法值。`base64` 格式的字符串会返回原始值。无效地址则会返回[默认占位图](https://pic1.zhuanstatic.com/zhuanzh/5cad2d3f-61a8-4184-a0a3-5cd3bfea006e.png)
 * @param {Number} width 在 `devicePixelRatio` 为 `3` 的屏幕上会自动乘以 `1.5`，不填则返回原始尺寸
 * @param {Number} height 预期的宽度，不传则自适应
 * @param {Object} option 自定义选项
 * @param {Number} option.wxAvatarWidth 处理微信头像链接时，期望的尺寸，合法的值为 `0、46、64、96、132`，默认取链接中携带的原始尺寸或 `96`
 * @param {Boolean} option.useOrigin 禁用在 `devicePixelRatio` 大于 `2` 的屏幕上 `width` 自动乘以 `devicePixelRatio / 2` 的功能
 * @param {Boolean} option.disableWebp 禁用 `webp` 格式。该参数的一个使用场景在于：在支持 `webp` 格式的设备上通过 `setPicSize` 获取的链接分享到不支持的设备
 * @param {Boolean} option.ssrWebp 在服务端判断是否使用 `webp` 格式
 * @return {String}
 * 
 * @example

import { setPicSize } from '@zz-common/zz-utils';
const url = 'n_v255b2cf20d9b3405fa6fc930e89fb76f6.jpg';

this.pic = setPicSize(url, 400);

// return:
// https://pic6.zhuanstatic.com/zhuanzh/n_v255b2cf20d9b3405fa6fc930e89fb76f6.jpg?w=400&t=5&qa=90
// 其中 t=5&qa=90 的意思是，支持webp格式，压缩比为90%

 */


export default function setPicSize(url, width, height, option) {
  // | 分割的字符串取第一个合法值
  if (typeof url === 'string' && url.indexOf('|') !== -1) {
    url = url.split('|').filter(function (item) {
      return isValid(item);
    })[0];
  }

  if (isArray(url)) {
    return url.map(function (item) {
      return logic(item, width, height, option);
    });
  }

  return logic(url, width, height, option);
}